import React from "react";

interface FeatureHighlightProps {
    title: string;
    description: string;
}

const FeatureHighlight: React.FC<FeatureHighlightProps> = ({
    title,
    description,
}) => {
    return (
        <article className="flex-1">
            <h2 className="mb-5 text-3xl font-bold leading-tight text-black max-md:text-2xl max-sm:text-2xl">
                {title}
            </h2>
            <p className="text-sm leading-normal text-black">{description}</p>
        </article>
    );
};

export default FeatureHighlight;
